var _mask, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuWard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_250_2844",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 5C17.5523 5 18 5.44772 18 6V20H20V21H4V20H6V6C6 5.44772 6.44772 5 7 5H17ZM11 15C10.4477 15 10 15.4477 10 16V20H14V16C14 15.4477 13.5523 15 13 15H11ZM11 7V9H9V11H11V13H13V11H15V9H13V7H11Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5C17.5523 5 18 5.44772 18 6V20H20V21H4V20H6V6C6 5.44772 6.44772 5 7 5H17ZM11 15C10.4477 15 10 15.4477 10 16V20H14V16C14 15.4477 13.5523 15 13 15H11ZM11 7V9H9V11H11V13H13V11H15V9H13V7H11Z",
    fill: "url(#paint0_linear_250_2844)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H17.5V20.5H18V20ZM20 20H20.5V19.5H20V20ZM20 21V21.5H20.5V21H20ZM4 21H3.5V21.5H4V21ZM4 20V19.5H3.5V20H4ZM6 20V20.5H6.5V20H6ZM7 5V4.5V5ZM10 20H9.5V20.5H10V20ZM14 20V20.5H14.5V20H14ZM14 16H14.5H14ZM11 7V6.5H10.5V7H11ZM11 9V9.5H11.5V9H11ZM9 9V8.5H8.5V9H9ZM9 11H8.5V11.5H9V11ZM11 11H11.5V10.5H11V11ZM11 13H10.5V13.5H11V13ZM13 13V13.5H13.5V13H13ZM13 11V10.5H12.5V11H13ZM15 11V11.5H15.5V11H15ZM15 9H15.5V8.5H15V9ZM13 9H12.5V9.5H13V9ZM13 7H13.5V6.5H13V7ZM17 5V5.5C17.2761 5.5 17.5 5.72386 17.5 6H18H18.5C18.5 5.17157 17.8284 4.5 17 4.5V5ZM18 6H17.5V20H18H18.5V6H18ZM18 20V20.5H20V20V19.5H18V20ZM20 20H19.5V21H20H20.5V20H20ZM20 21V20.5H4V21V21.5H20V21ZM4 21H4.5V20H4H3.5V21H4ZM4 20V20.5H6V20V19.5H4V20ZM6 20H6.5V6H6H5.5V20H6ZM6 6H6.5C6.5 5.72386 6.72386 5.5 7 5.5V5V4.5C6.17157 4.5 5.5 5.17157 5.5 6H6ZM7 5V5.5H17V5V4.5H7V5ZM11 15V14.5C10.1716 14.5 9.5 15.1716 9.5 16H10H10.5C10.5 15.7239 10.7239 15.5 11 15.5V15ZM10 16H9.5V20H10H10.5V16H10ZM10 20V20.5H14V20V19.5H10V20ZM14 20H14.5V16H14H13.5V20H14ZM14 16H14.5C14.5 15.1716 13.8284 14.5 13 14.5V15V15.5C13.2761 15.5 13.5 15.7239 13.5 16H14ZM13 15V14.5H11V15V15.5H13V15ZM11 7H10.5V9H11H11.5V7H11ZM11 9V8.5H9V9V9.5H11V9ZM9 9H8.5V11H9H9.5V9H9ZM9 11V11.5H11V11V10.5H9V11ZM11 11H10.5V13H11H11.5V11H11ZM11 13V13.5H13V13V12.5H11V13ZM13 13H13.5V11H13H12.5V13H13ZM13 11V11.5H15V11V10.5H13V11ZM15 11H15.5V9H15H14.5V11H15ZM15 9V8.5H13V9V9.5H15V9ZM13 9H13.5V7H13H12.5V9H13ZM13 7V6.5H11V7V7.5H13V7Z",
    fill: "url(#paint1_linear_250_2844)",
    mask: "url(#path-1-inside-1_250_2844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_2844",
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_2844",
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuWard);
export default __webpack_public_path__ + "static/media/ic-menu-ward.cb4aa96a50f04787ff5aee3967528d71.svg";
export { ForwardRef as ReactComponent };